<template>
  <div v-if="showList" class="p-lottery-preset-content">
    <div v-if="historyPrize.length > 0" class="p-preset__history">
      <p>{{ t('plvIA.lottery.history') }}</p>
      <ul>
        <li
          v-for="(item, index) in historyPrize"
          :key="index"
          @click.stop="selectPrize(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="p-preset__default">
      <p>{{ t('plvIA.lottery.referenceName') }}</p>
      <ul>
        <li
          v-for="(item, index) in [
            t('plvIA.lottery.grandPrize'),
            t('plvIA.lottery.firstPrize'),
            t('plvIA.lottery.secondPrize'),
            t('plvIA.lottery.thirdPrize')
          ]"
          :key="index"
          @click.stop="selectPrize(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  mixins: [Locale],
  props: {
    historyPrize: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showList: false
    };
  },

  mounted() {
    document.body.addEventListener('click', this.handleClickBody);
  },

  beforeDestroy() {
    document.body.removeEventListener('click', this.handleClickBody);
  },

  methods: {
    handleClickBody() {
      this.showList = false;
    },

    selectPrize(val) {
      this.showList = false;
      this.$emit('get-prize', val);
    },

    listShow() {
      this.showList = true;
    }
  }
};
</script>

<style lang="scss">
.p-lottery-preset-content {
  position: absolute;
  left: 108px;
  width: 320px;
  top: 40px;
  max-height: 130px;
  padding: 0 8px 20px;
  overflow: auto;
  background-color: #fff;
  font-size: 12px;
  z-index: 999;
  border: 1px solid #cfd8dc;
  border-top: none;
  color: #333333;

  p {
    margin-top: 20px;
    color: #333333;
    font-size: 14px;
  }

  ul {
    display: flex;
    justify-content: flex-start;
    margin-top: 12px;
    flex-wrap: wrap;
  }

  li {
    height: 32px;
    max-width: 170px;
    margin: 8px 8px 0 0;
    line-height: 30px;
    padding: 0 12px;
    border: 1px solid #b0bec5;
    color: #333;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;

    &:hover,
    &:active {
      border: 1px solid rgba(33, 150, 243, 1);
      color: #2196f3;
    }
  }
}
</style>
